import { ApiRequestError } from '@/lib/apiRequestError';

/** Messaggi operativi per il dettaglio Deal, senza esporre il backend. */
export function dealDetailLoadError(error: unknown): string {
  const status = error instanceof ApiRequestError ? error.status : undefined;
  if (status === 401) return 'La sessione è scaduta. Accedi di nuovo per aprire l’opportunità.';
  if (status === 404) return 'Questa opportunità non è più disponibile o non è accessibile.';
  if (status === 503) return 'Il controllo di accesso è temporaneamente non disponibile. Riprova tra poco.';
  return 'Non è stato possibile caricare l’opportunità. Riprova.';
}
